export default __webpack_public_path__ + "assets/images/cf52f6e72c81c71b33aa947085e7e03a.svg";